<script>
export default {
  props: {
    room: { type: Object, required: true },
    value: { type: Boolean, required: true },
  },
  computed: {
    modalModel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    carouselData() {
      return this.room.images.map(
        (img) =>
          `<div
            class="bg-cover bg-center"
            style="background-image: url(${img.src}); height: 22rem;"
          />`
      )
    },
  },
}
</script>

<template>
  <BaseModal v-model="modalModel" :title="room.name" size="3xl">
    <template v-if="modalModel">
      <div class="mb-6">
        <Carousel :data="carouselData" :controls="true" />
      </div>

      <div class="flex flex-wrap">
        <div class="w-full">
          <h5 class="text-lg text-gold mb-4 border-b-2 border-gold-500">
            Description
          </h5>
          <p class="mb-6">{{ room.description }}</p>
        </div>
        <!-- Room Description -->

        <div class="w-full lg:w-1/2">
          <div class="mr-0 lg:mr-3 mb-6">
            <h5 class="text-lg text-gold mb-4 border-b-2 border-gold-500">
              Information
            </h5>
            <ul class="flex flex-wrap text-sm leading-relaxed">
              <li
                v-if="room.information.wifiIncluded"
                class="w-1/2 md:w-full mb-3"
              >
                <div class="flex items-center">
                  <BaseIcon
                    class="fa-fw mr-3 text-lg text-gray-600"
                    name="wifi"
                  />
                  Free Wi-Fi
                </div>
              </li>
              <li class="w-1/2 md:w-full mb-3">
                <div class="flex items-center">
                  <BaseIcon
                    class="fa-fw mr-3 text-lg text-gray-600"
                    name="home"
                  />
                  Room size: {{ room.information.sizeSqm }} m²
                </div>
              </li>
              <li class="w-1/2 md:w-full mb-3">
                <div class="flex items-center">
                  <BaseIcon
                    class="fa-fw mr-3 text-lg text-gray-600"
                    name="bed"
                  />
                  {{ room.information.bedType }}
                </div>
              </li>
              <li class="w-1/2 md:w-full mb-3">
                <div class="flex items-center">
                  <BaseIcon
                    class="fa-fw mr-3 text-lg text-gray-600"
                    name="mountain"
                  />
                  {{ room.information.view }}
                </div>
              </li>
              <li class="w-1/2 md:w-full mb-3">
                <div class="flex items-center">
                  <BaseIcon
                    class="fa-fw mr-3 text-lg text-gray-600"
                    name="bath"
                  />
                  {{ room.information.bathroom }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- End of Room Description -->

        <!-- Room Amenities -->
        <div class="w-full lg:w-1/2">
          <div class="ml-0 lg:ml-3 mb-6">
            <h5 class="text-lg text-gold mb-4 border-b-2 border-gold-500">
              Features
            </h5>
            <ul class="flex flex-wrap">
              <li
                v-for="(facility, index) in room.facilities"
                :key="index"
                class="w-1/2 mb-2 flex"
              >
                <div>
                  <span>
                    <i class="fas fa-check mr-2"></i>
                  </span>
                </div>
                <p>{{ facility }}</p>
              </li>
            </ul>
          </div>
        </div>
        <!-- End of Room Amenities -->
      </div>
    </template>
  </BaseModal>
</template>
